import { reactive, ref, watch } from 'vue';
import { apiFavoriteArticleList, apiFavoriteIdList } from '@/request/api';

export default ({ currentFavoriteId }) => {

    const query = reactive({
        pageNum: 1,
        pageSize: 10,
    })
    const total = ref(0);
    const listData = ref([]);
    const all = ref(false);
    const checkedList = ref([]);// 已选中文章id集合

    // 获取文章列表
    async function setListData() {
        const params = { ...query };
        if (currentFavoriteId.value) {
            params['id'] = currentFavoriteId.value
        }
        const { data } = await apiFavoriteArticleList(params);
        total.value = data?.total || 0;
        listData.value = data?.list || [];
        // 设置文章选中状态
        listData.value = listData.value.map(item => {
            item.checked = false;// 默认值
            // 全选时
            if (all.value) {
                item.checked = true;
            }
            // 已选中时
            if (checkedList.value.includes(item.articleId)) {
                item.checked = true;
            }
            return item;
        })
    }

    // 搜索
    function search() {
        query.pageNum = 1;
        setListData();
    }

    // 分页
    watch(() => query.pageNum, setListData);

    // 收藏夹切换
    watch(() => currentFavoriteId.value, () => {
        all.value = false;
        checkedList.value = [];
        search();
    });

    // 全选切换
    async function allChange() {
        // 切换当前页文章选中状态
        listData.value = listData.value.map(item => {
            item.checked = all.value;
            return item;
        })
        // 如果全选取消，则清空已选中文章id集合
        if (!all.value) {
            checkedList.value = [];
            return;
        }
        // 如果全选勾选，则获取该收藏夹中所有文章id集合
        const { data } = await apiFavoriteIdList({ favoriteId: currentFavoriteId.value });
        checkedList.value = data || [];
    }

    // 单个切换
    function checkedChange(e, item) {
        if (e) {
            checkedList.value.push(item.articleId);
            if (checkedList.value.length === listData.value.length) {
                all.value = true;
            }
        } else {
            checkedList.value = checkedList.value.filter(id => id !== item.articleId);
            all.value = false;
        }
    }

    setListData();

    return { total, listData, query, setListData, all, checkedList, checkedChange, allChange }
}